const DEV = 'development'
const HOST_CONFIG = {
  templatePath: `${window.location.protocol}//reportoss.kaow.cn/template`,
  publicMode: DEV
}

switch (DEV) {
  case 'development':
    HOST_CONFIG.templatePath += '/dev/import'
    break
  case 'test':
    HOST_CONFIG.templatePath += '/test/import'
    break
  case 'production':
    // HOST_CONFIG.templatePath += '/production/import'
    HOST_CONFIG.templatePath += '/dev/import'
    break
}

export default HOST_CONFIG



// WEBPACK FOOTER //
// ./src/config/host-config.js